import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';
import MessageUtils from "../../../utils/MessageUtils";
import {
    LOADING,
    LOAD_MENUS_SUCCESS,
    REORDER_MENUS_SUCCESS,
    RESET_QUESTIONS,
    RESET_ANSWERS,
    RESET_PRODUCTS,
    RESET_CATEGORIES,
    RESET_MENUS,
    PUBLISH_IN_PROGRESS,
    RESET_SUB_QUESTIONS,
    RESET_SUB_ANSWERS,
    LOAD_MENUS_FOR_CSV_CREATE_EDIT_SUCCESS
} from '../../types';
import { convertStringToBoolean, redirectToPageNotFound } from "../../../utils/CommonUtils";

export const loadMenus = (restaurantId, saveInMenuProductCategoryReducer) => {
    return (dispatch, getState) => {
        doLoadMenus(restaurantId, dispatch, getState, saveInMenuProductCategoryReducer);
    }
}

export const doLoadMenus = (restaurantId, dispatch, getState, saveInMenuProductCategoryReducer) => {
    dispatch({ type: LOADING, payload: true });

    const url = `/restaurant/${restaurantId}/menu-draft`;

    axios().get(url)
        .then(response => {
            if (response.status === 204) {
                redirectToPageNotFound(dispatch)
            } else if (saveInMenuProductCategoryReducer) {
                loadMenusSuccessInMenuProductCategoryReducer(dispatch, response);
            } else {
                loadMenusSuccess(dispatch, response)
            }
        })
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:menusActions.loadMenusFailure')));
}

const loadMenusSuccessInMenuProductCategoryReducer = (dispatch, response) => {
    dispatch({ type: LOAD_MENUS_FOR_CSV_CREATE_EDIT_SUCCESS, payload: response.data });
}

const loadMenusSuccess = (dispatch, response, saveMessageSuccess, deleteMessageSuccess, publishMessageSuccess) => {
    if (saveMessageSuccess !== undefined && saveMessageSuccess !== null && saveMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:menusActions.saveMenuSuccess'));
    }

    if (deleteMessageSuccess !== undefined && deleteMessageSuccess !== null && deleteMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:menusActions.deleteMenuSuccess'));
    }

    if (publishMessageSuccess !== undefined && publishMessageSuccess !== null && publishMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:menusActions.publishMenuSuccess'));
        dispatch({ type: PUBLISH_IN_PROGRESS });
    }

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: RESET_CATEGORIES });
    dispatch({ type: RESET_PRODUCTS });
    dispatch({ type: RESET_QUESTIONS });
    dispatch({ type: RESET_ANSWERS });
    dispatch({ type: RESET_SUB_QUESTIONS });
    dispatch({ type: RESET_SUB_ANSWERS });
    dispatch({ type: LOAD_MENUS_SUCCESS, payload: response.data });
};

export const resetMenus = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: RESET_MENUS });
    }
}

export const saveMenu = (state, restaurantId, invalidSubmit, callback, publishMenuCallback) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        const menuData = {
            "restaurantId": restaurantId,
            "name": state.name,
            "active": convertStringToBoolean(state.active),
            "availableTimes": state.availableTimes,
            "menuAvailableAllDay": state.menuAvailableAllDay,
            "disableNotes": convertStringToBoolean(state.disableNotes)
        };

        if (!state.menuAvailableAllDay && !state.availableTimes.length) {
            MessageUtils.errorMessageResponse(dispatch, undefined, i18n.t('actions:menusActions.noOpeningHours'));
            return;
        }

        if (state.id === -1) {
            const url = `/menu-draft`;

            axios().post(url, menuData)
                .then((response) => {
                    saveMenuSuccess(dispatch, restaurantId, publishMenuCallback);
                    if (!publishMenuCallback) {
                        callback();
                    }
                })
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:menusActions.saveMenuFailure')));
        } else {
            const url = `/menu-draft/${state.id}`;

            axios().put(url, menuData)
                .then((response) => {
                    saveMenuSuccess(dispatch, restaurantId, publishMenuCallback);
                    if (!publishMenuCallback) {
                        callback();
                    }
                })
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:menusActions.saveMenuFailure')));
        }
    }
}

const saveMenuSuccess = (dispatch, restaurantId, publishMenuCallback) => {

    if (publishMenuCallback) {
        publishMenuCallback();
    }

    const url = `/restaurant/${restaurantId}/menu-draft`;

    axios().get(url)
        .then(response => loadMenusSuccess(dispatch, response, true))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:menusActions.loadMenusFailure')));
};

export const deleteMenu = (state, restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/menu-draft/${state.id}`;

        axios().delete(url)
            .then(response => deleteMenuSuccess(dispatch, restaurantId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:menusActions.deleteMenuFailure')));
    }
}

const deleteMenuSuccess = (dispatch, restaurantId) => {

    const url = `/restaurant/${restaurantId}/menu-draft`;

    axios().get(url)
        .then(response => loadMenusSuccess(dispatch, response, false, true))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:menusActions.loadMenusFailure')));
}

export const publishMenu = (state, restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/menu-draft/${state.id}/publish`;

        axios().put(url, {})
            .then(response => publishMenuSuccess(dispatch, response, restaurantId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:menusActions.publishMenuFailure')));
    }
}

const publishMenuSuccess = (dispatch, response, restaurantId) => {
    if (response.data.code === 403) {
        MessageUtils.errorMessageResponse(dispatch, response.data, i18n.t('actions:menusActions.alreadyRunningPublish'))
    } else {
        const url = `/restaurant/${restaurantId}/menu-draft`;

        axios().get(url)
            .then(response => loadMenusSuccess(dispatch, response, false, false, true))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:menusActions.loadMenusFailure')));
    }
}

export const reorderMenus = (menus, restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/menu-draft/reorder`;

        axios().put(url, menus)
            .then(response => reorderMenusSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:menusActions.reorderItemsFailure')));
    }
}

const reorderMenusSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: REORDER_MENUS_SUCCESS, payload: response.data });
}

export const publishAll = (restaurantId, callback) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });
        callback();
        const url = `/restaurant/${restaurantId}/publish`;

        axios().put(url, {})
            .then(response => publishAllSuccess(dispatch, response, getState, restaurantId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:menusActions.publishAllFailure')));
    }
}

const publishAllSuccess = (dispatch, response, getState, restaurantId) => {
    if (response.data.code === 403) {
        MessageUtils.errorMessageResponse(dispatch, response.data, i18n.t('actions:menusActions.alreadyRunningPublish'))
    } else {
        dispatch({ type: LOADING, payload: false });
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:menusActions.publishAllSuccess'));

        doLoadMenus(restaurantId, dispatch, getState);
    }
}



// WEBPACK FOOTER //
// ./src/actions/restaurants/posmenu/MenuActions.js